<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="!solicitacoesHonra || !solicitacoesHonra.length">
    Não foram encontradas solicitações de honra com os filtros informados.
  </div>

  <div class="row" *ngIf="solicitacoesHonra && solicitacoesHonra.length">
    <div *ngIf="mostrarExportarSolicitacoes">
      <button  class="btn btn-secondary float-end" type="button" (click)="exportarSolicitacoesHonra()"
        placement="top" ngbTooltip="Exporta todas as solicitações de honra listadas">
      <i class="fa fa-file"></i> Exportar Solicitações</button>
    </div>

    <bn-paginacao [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-agente" scope="col" *ngIf="mostrarExportarSolicitacoes && !ehAgenteFinanceiro">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgenteFinanceiro'"
                  [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id-sh" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'id'"
                  [nomeAtributoExibicao]="'Id. Sol. Honra'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id-operacao-externo" scope="col" *ngIf="mostrarExportarSolicitacoes">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idOperacaoExterno'"
                  [nomeAtributoExibicao]="'Id. externo operação'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-sistema-contrato" scope="col" *ngIf="mostrarExportarSolicitacoes">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'contratoRepasse'" 
                    [nomeAtributoExibicao]="'Sist./Contrato'"(aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>              
              <th id="col-nome-janela" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeJanela'" [nomeAtributoExibicao]="'Janela'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-parcela-inicial-honra" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataParcelaInicialASerHonrada'" [nomeAtributoExibicao]="'Parc.inicial honra'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-nome-valorEstimado" scope="col"  class="moeda">
                  <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorEstimadoHonra'" [nomeAtributoExibicao]="'Valor estimado'"
                    (aoClickar)="mudancaOrdenacao($event)">
                  </bn-ordenacao>
                </th>
              <th id="col-estado" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'estado'" [nomeAtributoExibicao]="'Estado'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th scope="col"></th> <!--lupa para visualizar os detalhes-->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let solicitacaoHonra of solicitacoesHonra" id="pointer" [routerLink]="['/solicitacoes-honra', solicitacaoHonra.id]" >
              <td *ngIf="mostrarExportarSolicitacoes && !ehAgenteFinanceiro">{{ nomeAgente(solicitacaoHonra.cnpjAgenteFinanceiro) }}</td>
              <td>{{ solicitacaoHonra.id }}</td>
              <td *ngIf="mostrarExportarSolicitacoes">{{ solicitacaoHonra.idOperacaoExterno }}</td>
              <td *ngIf="mostrarExportarSolicitacoes">{{ solicitacaoHonra.contratoRepasse ? solicitacaoHonra.sistemaRepasse + '/' + solicitacaoHonra.contratoRepasse : ''}}</td>
              <td>{{ solicitacaoHonra.nomeJanela}}</td>
              <td>{{ solicitacaoHonra.dataParcelaInicialASerHonrada | date: 'dd/MM/yyyy'}}</td>
              <td class="moeda">{{ solicitacaoHonra.valorEstimadoHonra | bnMask: 'MOEDA'}}</td>
              <td>{{ solicitacaoHonra.estado.nomeEstado }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>